import { LocationFilter } from './components/filters/location';
import TimezoneFilter from './components/filters/timeZone';
import { CompanyFilter } from './components/filters/company';
import { CompanySizeFilter } from './components/filters/companySize';
import { CompanyFundingStageFilter } from './components/filters/companyFundingStage';
import { InPortcoFilter } from './components/filters/inPortco';
import { JobTitleFilter } from './components/filters/jobTitle';
import { SeniorityFilter } from './components/filters/seniority';
import { IndustryFilter } from './components/filters/industry';
import { SkillsFilter } from './components/filters/skills';
import { SharedListFilter } from './components/filters/sharedList';
import { TagsFilter } from './components/filters/tags';
import { SourceFilter } from './components/filters/source';
import { JobApplicationsFilter } from './components/filters/jobApplications';
import { AppliedJobsFilter } from './components/filters/appliedJobs';
import { EnrichmentStatusFilter } from './components/filters/enrichmentStatus';
import { TalentNetworkSignupFilter } from './components/filters/talentNetworkSignup';
import { SignupJobFunctionFilter } from './components/filters/jobFunction';
import { SignupLevelOfExperienceFilter } from './components/filters/signupLevelOfExperience';
import { SignupWorkEnvironmentFilter } from './components/filters/workEnvironment';
import { SignupLocationsFilter } from './components/filters/signupLocations';
import { SignupJobSearchStatusFilter } from './components/filters/signupJobSearchStatus';
import { SignupHasResumeFilter } from './components/filters/signupHasResume';
import { SignupDateFilter } from './components/filters/signupDate';
import { ContactOfFilter } from './components/filters/contactOf';
import { YearsOfExperienceFilter } from './components/filters/yearsOfExperience';
import { YearsInCurrentCompanyFilter } from './components/filters/yearsInCurrentCompany';
import { FirstSeenFilter } from './components/filters/firstSeen';
import { BusinessModelFilter } from './components/filters/businessModel';

export const createGroups = ({
  sharedList,
  filters,
  extendedMode,
  isTalentNetworkEnabled,
  showListFilters,
  showTalentNetworkFilters,
}) => [
  {
    id: 'network',
    title: 'Network',
    show: true,
    filters: [
      {
        id: 'sharedListIds',
        Component: SharedListFilter,
        props: {},
        show: showListFilters,
      },
      {
        id: 'tags',
        Component: TagsFilter,
        props: { sharedList },
        show: extendedMode,
      },
      {
        id: 'importerIds',
        Component: ContactOfFilter,
        props: {},
        show: true,
      },
      {
        id: 'inPortco',
        Component: InPortcoFilter,
        props: {},
        show: extendedMode,
      },
      {
        id: 'sources',
        Component: SourceFilter,
        props: {},
        show: extendedMode,
      },
      {
        id: 'daysSinceAdded',
        Component: FirstSeenFilter,
        props: {},
        show: extendedMode,
      },
    ],
  },
  {
    id: 'experience',
    title: 'Experience',
    show: true,
    filters: [
      {
        id: 'jobTitles',
        Component: JobTitleFilter,
        props: { sharedList, jobTitlesIncluded: filters.jobTitlesIncluded },
        show: true,
      },
      {
        id: 'seniorities',
        Component: SeniorityFilter,
        props: {},
        show: true,
      },
      {
        id: 'yearsOfExperience',
        Component: YearsOfExperienceFilter,
        props: {},
        show: true,
      },
      {
        id: 'industryTags',
        Component: IndustryFilter,
        props: { sharedList, industryTagsYears: filters.industryTagsYears },
        show: true,
      },
      {
        id: 'skills',
        Component: SkillsFilter,
        props: { sharedList },
        show: true,
      },
      {
        id: 'bizModels',
        Component: BusinessModelFilter,
        props: { bizModelYears: filters.bizModelYears },
        show: true,
      },
    ],
  },
  {
    id: 'company',
    title: 'Company',
    show: true,
    filters: [
      {
        id: 'companyName',
        Component: CompanyFilter,
        props: {
          companyName: filters.companyName,
          companyDomain: filters.companyDomain,
          companyNameIncluded: filters.companyNameIncluded,
          companyNamePeriod: filters.companyNamePeriod,
          sharedList,
        },
        additionalCountKeys: ['companyName', 'companyDomain'],
        show: true,
      },
      {
        id: 'yearsInCurrentCompany',
        Component: YearsInCurrentCompanyFilter,
        props: {},
        show: true,
      },
      {
        id: 'currentCompanySizes',
        Component: CompanySizeFilter,
        props: {},
        show: true,
      },
      {
        id: 'companyStages',
        Component: CompanyFundingStageFilter,
        props: {
          companyStages: filters.companyStages,
          stageTransitions: filters.stageTransitions,
          activePositionsOrganizationStages: filters.activePositionsOrganizationStages,
        },
        additionalCountKeys: ['stageTransitions', 'activePositionsOrganizationStages'],
        show: true,
      },
    ],
  },
  {
    id: 'location',
    title: 'Location',
    show: true,
    filters: [
      {
        id: 'locationIds',
        Component: LocationFilter,
        props: { locationRadius: filters.locationRadius },
        show: true,
      },
      {
        id: 'tzAbbreviation',
        Component: TimezoneFilter,
        props: {},
        show: true,
      },
    ],
  },
  {
    id: 'talent-network',
    title: 'Talent network',
    show: extendedMode && isTalentNetworkEnabled,
    filters: [
      {
        id: 'hasSignupInfo',
        Component: TalentNetworkSignupFilter,
        props: {},
        show: true,
      },
      {
        id: 'signupJobFunctions',
        Component: SignupJobFunctionFilter,
        props: { sharedList },
        show: true,
      },
      {
        id: 'signupSeniorities',
        Component: SignupLevelOfExperienceFilter,
        props: {},
        show: true,
      },
      {
        id: 'signupWorkEnvironments',
        Component: SignupWorkEnvironmentFilter,
        props: {},
        show: true,
      },
      {
        id: 'signupLocations',
        Component: SignupLocationsFilter,
        props: { sharedList },
        show: true,
      },
      {
        id: 'signupJobSearchStatuses',
        Component: SignupJobSearchStatusFilter,
        props: {},
        show: true,
      },
      {
        id: 'signupHasResume',
        Component: SignupHasResumeFilter,
        props: {},
        show: true,
      },
      {
        id: 'signupDaysSinceJoined',
        Component: SignupDateFilter,
        props: {},
        show: true,
      },
    ],
  },
  {
    id: 'job-board-applicants',
    title: 'Job board applications',
    show: extendedMode && showTalentNetworkFilters,
    filters: [
      {
        id: 'jobApplications',
        Component: JobApplicationsFilter,
        props: {},
        show: true,
      },
      {
        id: 'jobApplicationsJobs',
        Component: AppliedJobsFilter,
        props: {},
        show: true,
      },
    ],
  },
  {
    id: 'profile-status',
    title: 'Profile status',
    show: extendedMode,
    filters: [
      {
        id: 'enrichmentStatus',
        Component: EnrichmentStatusFilter,
        props: { value: filters.enrichmentStatus },
        show: true,
      },
    ],
  },
];
